<template>
  <div
    @mouseover="isHovering = true"
    @mouseout="isHovering = false"
    @click="clicked"
    class="nav-item cursor-pointer flex flex-col lg:flex-row items-center p-3"
    :class="{
      'text-primary': active == item.active,
      'bg-primary-gradient text-white rounded-lg': isHovering
    }"
  >
    <div class="lg:pr-2">
      <feather-icon class="hidden lg:block" :icon="item.icon"></feather-icon>
      <feather-icon
        class="lg:hidden"
        :icon="item.icon"
        :badge="item.badge"
        :badgeColor="item.badgeColor"
      >
      </feather-icon>
    </div>
    <div class="lg:text-base font-semibold flex-1">{{ item.text }}</div>
    <vs-chip
      class="hidden lg:flex"
      :color="item.badgeColor || 'primary'"
      v-if="item.badge > 0"
      >{{ item.badge }}
    </vs-chip>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    item: {
      type: Object
    },
    active: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      screenWidth: window.innerWidth,
      isHovering: false
    };
  },
  methods: {
    clicked() {
      if (this.$route.path !== this.item.to) this.$router.push(this.item.to);
      this.setNavigationActive(this.item.active);
      this.$store.dispatch("globalApp/setShowDetail", false);
      this.$store.dispatch("globalApp/toggleCreate", false);
      this.$store.dispatch("globalApp/toggleEdit", false);
    },
    ...mapActions({
      setNavigationActive: "globalApp/setNavigationActive"
    })
  }
};
</script>
